import React, {Component} from "react";
import {ButtonGroup, Dropdown, DropdownButton, FormGroup} from "react-bootstrap";

export interface RegulatoryModeNumberSelectProps {
    onChange: (eventKey: string | null, e: React.SyntheticEvent<unknown>) => void;
    value: number;
}

export default class RegulatoryModeNumberSelect extends Component<RegulatoryModeNumberSelectProps> {

    render = () =>(
        <FormGroup>
            <DropdownButton as={ButtonGroup} title={this.props.value|| ""} onSelect={this.props.onChange} className="fixed-w5">
                <Dropdown.Item active={this.props.value == 0} eventKey="0">none</Dropdown.Item>
                <Dropdown.Item active={this.props.value == 1} eventKey="1">1</Dropdown.Item>
                <Dropdown.Item active={this.props.value == 2} eventKey="2">2</Dropdown.Item>
                <Dropdown.Item active={this.props.value == 3} eventKey="3">3</Dropdown.Item>
                <Dropdown.Item active={this.props.value == 4} eventKey="4">4</Dropdown.Item>
            </DropdownButton>
        </FormGroup>
    );
}
